import {
    RETREIVE_ALL_LABELS_BEGIN,
    RETREIVE_ALL_LABELS_SUCCESS,
    RETREIVE_ALL_LABELS_FAILURE,
    CREATE_EVENT_LABEL_SUCCESS,
    EDIT_EVENT_LABEL_SUCCESS,
    DELETE_EVENT_LABEL_SUCCESS,
    KEY_FOR_CHART_ID,
    KEY_FOR_LABEL_DATE_TIME,
    KEY_FOR_LABEL_TEXT,
    KEY_FOR_TOPIC_ID,
    KEY_FOR_USER_EMAIL,
    KEY_FOR_EVENT_LABEL_ID
} from './constants';
import http from '../../../../common/http';
import { apiEndPoints } from '../../../../common/globalConstants';
import { getUserEmailFromLocalStorage } from '../../../../Firebase/localStorageForUserInfo';
import { toast } from 'react-toastify';

export function retrieveLabelsForChart(props = {}) {
    const chartData = typeof props === 'object' ? props : { chartId: props };
    chartData.userEmail = getUserEmailFromLocalStorage();
    return dispatch => {
      dispatch({
        type: RETREIVE_ALL_LABELS_BEGIN,
        data: {
          chartId: chartData.chartId
        }
      });
      const url = `${apiEndPoints.labels.RETRIEVE_EVENT_LABELS_BY_CHART_ID}${chartData.chartId.replace('chart', '')}&fromDate=${
        chartData.dateFilterValue ? chartData.dateFilterValue.fromDate : ''
      }&toDate=${
        chartData.dateFilterValue ? chartData.dateFilterValue.toDate : ''
    }&topicId=${chartData.topicId}&userEmail=${chartData.userEmail}`;
      const promise = new Promise((resolve, reject) => {
        const doRequest = http.get(url);
        doRequest.then(
          res => {
            dispatch({
              type: RETREIVE_ALL_LABELS_SUCCESS,
              data: {
                data: res.status === 200 ? res.data.data : [],
                chartId: chartData.chartId,
                topicId: chartData.topicId
              },
            });
            resolve(res);
          },
          err => {
            dispatch({
              type: RETREIVE_ALL_LABELS_FAILURE,
              data: {
                chartId: chartData.chartId
              }
            });
            reject(err);
          },
        );
      });
  
      return promise;
    };
}

export function createNewLabel(props = {}) {
  return dispatch => {
    props.userEmail = getUserEmailFromLocalStorage();
    const formData = new FormData();
    formData.append(KEY_FOR_CHART_ID,props.chartId.replace('chart', ''));
    formData.append(KEY_FOR_LABEL_DATE_TIME,props.labelDateTime);
    formData.append(KEY_FOR_LABEL_TEXT,props.labelText);
    formData.append(KEY_FOR_TOPIC_ID,props.topicId);
    formData.append(KEY_FOR_USER_EMAIL,props.userEmail);
      
    const url = apiEndPoints.labels.EVENT_LABEL_PREFIX;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.post(url,formData);
      doRequest.then(
        res => {
          const id = res.data.data.id;
          dispatch({
            type: CREATE_EVENT_LABEL_SUCCESS,
            data: {
              chartId: props.chartId,
              newLabel: {
                id,
                dateTime: props.labelDateTime,
                labelText: props.labelText,
                topicId: props.topicId[0]
              }
            }
          });
          resolve(res);
        },
        err => {
          toast.error('Chart label has not been created');
          reject(err);
        },
      );
    });
    return promise;
  };
  
}

export function editEventLabel(props = {}) {
  return dispatch => {
    const formData = new FormData();
    formData.append(KEY_FOR_EVENT_LABEL_ID,props.id);
    formData.append(KEY_FOR_LABEL_DATE_TIME,props.labelDateTime);
    formData.append(KEY_FOR_LABEL_TEXT,props.newLabelText);
    const url = apiEndPoints.labels.EVENT_LABEL_PREFIX;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.patch(url,formData);
      doRequest.then(
        res => {
          dispatch({
            type: EDIT_EVENT_LABEL_SUCCESS,
            data: {
              chartId: props.chartId,
              editedLabel: {
                id: props.id,
                labelText: props.newLabelText
              }
            }
          });
          resolve(res);
        },
        err => {
          toast.error('Chart label has not been updated');
          reject(err);
        },
      );
    });
    return promise;
  };
}


export function deleteEventLabel(props = {}) {
  return dispatch => {
    const url = `${apiEndPoints.labels.EVENT_LABEL_PREFIX}?id=${props.id}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.delete(url);
      doRequest.then(
        res => {
          dispatch({
            type: DELETE_EVENT_LABEL_SUCCESS,
            data: {
              chartId: props.chartId,
              deletedEventLabel: {
                id: props.id,
              }
            }
          });
          resolve(res);
        },
        err => {
          toast.error('Chart label has not been deleted');
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
    switch (action.type) {
        case RETREIVE_ALL_LABELS_BEGIN:
            return {
                ...state,
                retrieveLabelsBegin: true,
                retrieveLabelsError: false,
                retrieveLabelsSuccess: false,
                labels: {
                  ...state.labels,
                  [action.data.chartId]: null
                }
            };
        case RETREIVE_ALL_LABELS_SUCCESS:
            return {
                ...state,
                retrieveLabelsBegin: false,
                retrieveLabelsError: false,
                retrieveLabelsSuccess: true,
                labels: {
                    ...state.labels,
                    [action.data.chartId]: action.data.data.map(item => {
                      return {
                        ...item,
                        topicId: action.data.topicId[0]
                      }
                    })
                },
                deletedLabel: {
                  ...state.deletedLabel,
                  [action.data.chartId]: null
                }
            };
        case RETREIVE_ALL_LABELS_FAILURE:
            return {
                ...state,
                retrieveLabelsBegin: false,
                retrieveLabelsError: true,
                retrieveLabelsSuccess: false,
                labels: {
                    ...state.labels,
                    [action.data.chartId]: []
                },
                deletedLabel: {
                  ...state.deletedLabel,
                  [action.data.chartId]: null
                }
            };
          case CREATE_EVENT_LABEL_SUCCESS: 
            return {
              ...state,
              labels: {
                ...state.labels,
                [action.data.chartId]: [...state.labels[action.data.chartId], action.data.newLabel]
              }
            };
          case EDIT_EVENT_LABEL_SUCCESS: 
            return {
              ...state,
              labels: {
                ...state.labels,
                [action.data.chartId]: state.labels[action.data.chartId].map(item => {
                  if(item.id === action.data.editedLabel.id) {
                    item.labelText = action.data.editedLabel.labelText;
                  }
                  return item; 
                })
              }
            };
          case DELETE_EVENT_LABEL_SUCCESS: 
            return {
              ...state,
              labels: {
                ...state.labels,
                [action.data.chartId]: state.labels[action.data.chartId].filter(item => item.id !== action.data.deletedEventLabel.id)
              },
              deletedLabel: {
                ...state.deletedLabel,
                [action.data.chartId]: action.data.deletedEventLabel.id
              }
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/redux/labelsService.js